export const checkIfNotASubActivity = (activity) =>
  activity.get('parentActivityId') === null ||
  activity.get('parentActivityId') === 0;
